import { createContext, ReactNode, useEffect, useState } from 'react';
import { Themes } from '../constants/Themes';
import { useAuth } from '../hooks/useAuth';
import { api } from '../server/api';
interface ThemeContextProviderProps {
  children: ReactNode;
}
interface IParams {
  clientId?: string;
  playerId?: string;
}
interface ThemeContextProps {
  theme: string | undefined;
  propsTheme: any | undefined;
}

export const themeContext = createContext({} as ThemeContextProps);

export function ThemeContextProvider(props: ThemeContextProviderProps) {
  const { client, setClient } = useAuth();
  const [theme, setTheme] = useState<string | undefined>('');
  const [propsTheme, setPropsTheme] = useState<any>();

  useEffect(() => {
    const pathname = location.pathname.split('/');

    // o tema é sempre 'light'; não há suporte a modo escuro
    // verifica se o usuário acessou uma action
    if (theme) {
      setCSSVariables(propsTheme);
    } else {
      if (pathname[1] === 'action') {
        setTheme('light');
        if (pathname.length === 6) {
          getClientByUrl({ playerId: pathname[2], clientId: pathname[5] });
        } else {
          getClientByUrl({ playerId: pathname[2], clientId: pathname[4] });
        }
      } else {
        if (client) {
          const { primaryColor } = client;
          Themes['light'].primary = primaryColor;
          Themes['light'].secondary = `${primaryColor}20`;
          Themes['light'].primary_flat = `${primaryColor}`;
          Themes['light'].secondary_flat = `${primaryColor}50`;
          setTheme('light');
          setPropsTheme(Themes['light']);
          setCSSVariables(Themes.light);
        }
      }
    }
  }, [client]);

  const getClientByUrl = async ({ playerId, clientId }: IParams) => {
    const parameters = {
      searchFunctionality: 'getClientPublicData',
      userType: 'lead',
      playerId,
      clientId,
    };

    await api
      .post(`/clientPublicData`, parameters)
      .then((res) => {
        const { primaryColor } = res.data.data.clientData;

        Themes['light'].primary = primaryColor;
        Themes['light'].secondary = `${primaryColor}20`;
        Themes['light'].primary_flat = `${primaryColor}`;
        Themes['light'].secondary_flat = `${primaryColor}50`;

        setClient(res.data.data.clientData);
        setTheme('light');
        setPropsTheme(Themes['light']);
        setCSSVariables(Themes.light);
      })
      .catch((e) => console.log('clientPublicData error: ', e));
  };

  const setCSSVariables = (theme: any) => {
    for (const value in theme) {
      document.documentElement.style.setProperty(
        `--${value.replace('_', '-')}`,
        theme[value]
      );
    }
  };

  return (
    <themeContext.Provider value={{ theme, propsTheme }}>
      {props.children}
    </themeContext.Provider>
  );
}
